// import { NavLink } from "react-router-dom";

import './RST03.css';

import mapa from '../../../images/movilidad/mapa-restaurante-ruta03.jpg';

function Ruta() {
  return (
    <div className='full'>
      <img src={mapa} width="" height="" alt='' className='full cnt map' />
    </div>
  );
}

export default Ruta;
